export default "__VITE_ASSET__CnOBmpoe__"